import axios from "axios";

const apiGradosAcad = {	
	async readGradosAcad(noPlaza) {           
		const response = await axios.get("/api/gradosacad/"+noPlaza);  //Leer API de Grados Académicos
		return response.data;        
	},
	async createGradosAcad(requestData) {
		const response = await axios.post("/api/gradosacad", requestData);		
		return response.data;		
	},
	async updateGradosAcad(idGrado, requestData) {
		const response = await axios.put("/api/gradosacad/"+idGrado, requestData);
		return response.data;
	},
	async deleteGradosAcad(idGrado) {
		const response = await axios.delete("/api/gradosacad/"+idGrado);
		return response.data;
	}
};

export default apiGradosAcad;

